// Example PendingHoursList.js
import React from 'react';
import { volassisAPI } from '../services/api';

const PendingHoursList = ({ orgId, pendingHours, refresh }) => {
  const handleApprove = async (userId) => {
    await volassisAPI.approveAllHours(userId, orgId);
    refresh();
  };

  return (
    <table>
      <thead>
        <tr>
          <th>Volunteer</th>
          <th>Hours</th>
          <th>Approve</th>
        </tr>
      </thead>
      <tbody>
        {pendingHours.map(row => (
          <tr key={row.userId}>
            <td>{row.name}</td>
            <td>{row.hours}</td>
            <td>
              <button onClick={() => handleApprove(row.userId)}>Approve</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PendingHoursList;